import $ from "jquery"

window.jQuery = $
window.$ = $

// PLUGINS======================================================================================
import Inputmask from "inputmask"
import LazyLoad from "vanilla-lazyload"
import "@fancyapps/fancybox"

// MODULES======================================================================================
import "./js-modules/sliders.js"
import initAnimations from "./js-modules/animations.js"
import initPortfolioAnimations from "./js-modules/portfolio.js"
import initLoader from "./js-modules/loader.js"
import initDropdowns from "./js-modules/dropdowns.js"
import initShowmore from "./js-modules/showmore.js"
import initSelectBox from "./js-modules/selectbox.js"
import initMobilemenu from "./js-modules/mobilemenu.js"
import initScrollToTop from "./js-modules/scrollToTop";


// init ========================================================================================
document.addEventListener("DOMContentLoaded", () => {
    initLoader()

    let lazyLoadInstance = new LazyLoad()
    $("[data-fancybox]").fancybox({
        // smallBtn: true,
        touch: false,
        loop: true,
        btnTpl: {
            smallBtn: `<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="19.5122" width="27.5944" height="0.68986" transform="rotate(-45 0 19.5122)" fill="white" />
                            <rect x="0.487793" width="27.5944" height="0.68986" transform="rotate(45 0.487793 0)" fill="white" />
                        </svg>
                    </button>`,
        },
    })

    window.im = new Inputmask("+7 (999) 999-99-99")
    window.im.mask(document.querySelectorAll('input[type="tel"]'))


    window.refreshPortfolio = function () {
        initPortfolioAnimations()
    }
    setTimeout(() => {
        initScrollToTop()
    }, 0)
    setTimeout(() => {
        initMobilemenu()
    }, 0)
    setTimeout(() => {
            // console.log("анимации в портфолио временно отключены")
            initPortfolioAnimations()
        }
        , 0)
    setTimeout(() => {
        initAnimations()
    }, 0)
    setTimeout(() => {
        initDropdowns()
    }, 0)
    setTimeout(() => {
        initShowmore()
    }, 0)
    setTimeout(() => {
        initSelectBox("services-filter")
    }, 0)
})
